var _metadata, _sodipodiNamedview, _defs, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    id: "svg2",
    inkscapeVersion: "0.47 r22583",
    sodipodiDocname: "ADR 1.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3145"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1280,
    "inkscapeWindow-height": 976,
    id: "namedview3143",
    showgrid: "false",
    inkscapeZoom: 5.3400704,
    inkscapeCx: 75.192516,
    inkscapeCy: 49.771625,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 24,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g2818"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("inkscapePerspective", {
    sodipodiType: "inkscape:persp3d",
    inkscapeVp_x: "0 : 500 : 1",
    inkscapeVp_y: "0 : 1000 : 0",
    inkscapeVp_z: "1000 : 500 : 1",
    "inkscapePersp3d-origin": "500 : 333.33333 : 1",
    id: "perspective3147"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 5950,0 0,7197.12 -5950,0 L 0,0 z",
    id: "path22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2818",
    transform: "scale(0.1,0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,500 500,0 1000,500 c 0,0 -500,500 -500,500 L 0,500 z",
    id: "path2826",
    style: {
      fill: "#fc7e0c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13736741,0,0,-0.13736741,4.7212755,992.23093)",
    id: "g3779",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3798.52,4453.24 2.94,-0.14 133.58,-6.32 140.08,-6.63 904.98,-42.81 -37.65,28.95 -855.7,27.1 -162.62,5.15 -92.54,2.94 -35.48,1.12 -571.23,18.09 0.18,-0.31 573.46,-27.14",
    id: "path70",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3902.98,4481.31 21.15,-22.77 162.62,-5.15 65.27,74.25 -228.77,101.34 -60.78,-57.91 -86.88,-28.95 20.52,-79.52 35.48,-1.12 71.39,19.83",
    id: "path66",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2257.35,4494.03 -25.3,1.02 4.65,-8.39 20.65,7.37",
    id: "path24",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3611.9,6231.7 -88.52,40.49 -461.84,-1317.08 c 27.46,-9.84 54.01,-22.35 78.88,-37.36 L 3611.9,6231.7",
    id: "path34",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3548.69,5598.94 -45.56,27.83 -359.83,-710.84 c 1.93,-1.19 3.84,-2.43 5.76,-3.66 l 399.63,686.67",
    id: "path36",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3323.42,5809.01 -50.61,30.38 -225.3,-879.39 c 0.79,-0.25 1.55,-0.56 2.33,-0.81 l 273.58,849.82",
    id: "path38",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3109.59,5517.01 39.33,57.37 67.99,74 -37.47,121.21 -51.33,0.92 -22.21,-56.44 -43.49,17.11 -22.2,-107.78 46.25,-21.73 23.13,-84.66",
    id: "path40",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3527.72,5457.95 -28.76,-40.38 -16.61,-84.08 58.08,-50.34 41.49,50.34 11.59,56.97 -25.4,68.04 -19.93,-21.02 -20.46,20.47",
    id: "path42",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3288.42,4893.08 -6.87,16.04 -55.46,-60.42 c 2.98,-3.19 5.99,-6.35 8.84,-9.63 l 53.49,54.01",
    id: "path44",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3396.88,5002.57 797.83,805.74 -45.92,45.92 -808.93,-881.58 42.18,29.61 14.84,0.31",
    id: "path46",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2993.95,4595.78 205.92,207.9 -14.94,0.18 -190.98,-208.08",
    id: "path48",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4192.4,5399.54 -1065.26,-750.94 1065.26,661.38 0,89.56",
    id: "path50",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3861.72,4908.11 -4.61,52.81 -626.63,-296.24 631.24,243.43",
    id: "path52",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3294.78,4878.25 84.97,39.04 18.37,-64.3 135.49,110.22 75.73,140.09 -119.36,-98.74 -93.1,-1.99 -14.84,-0.31 -42.18,-29.61 -65.75,-46.17 7.44,-17.36 6.87,-16.04 6.36,-14.83",
    id: "path54",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4043.15,5057.37 -20.68,-55.11 190.6,-22.97 -126.29,126.31 -43.63,-48.23",
    id: "path56",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4566.73,5289.31 128.61,-87.26 -2.31,156.16 -84.96,144.68 -39.04,-121.72 -103.34,-4.59 -29.85,-22.96 -13.78,-87.28 80.39,-45.91 64.28,68.88",
    id: "path58",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4985.88,5034.34 -26.06,55.01 -1875.96,-486.43 1902.02,431.42",
    id: "path60",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5214.63,4825.87 0,69.49 -2061.03,-349.32 0.22,-0.17 2060.81,280",
    id: "path62",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3798.75,4452.35 2.71,0.75 -2.94,0.14 0.23,-0.89",
    id: "path64",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3940.63,4440.77 127.4,-8.68 7.09,8.06 -140.08,6.63 5.59,-6.01",
    id: "path68",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3563.29,4314.89 10.18,14.13 95.86,-41.49 337.9,-87.08 14.46,98.45 -738.7,103.46 c -1.75,-4.65 -3.59,-9.27 -5.5,-13.83 l 285.8,-73.64",
    id: "path72",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3563.29,4314.89 -12.47,-17.3 -86.97,16.09 -24.13,-43.85 87.7,-65.06 230.67,-39.46 3.64,55.55 -37.98,43.12 -54.42,23.55 -95.86,41.49 -10.18,-14.13",
    id: "path74",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3737.62,4035.23 -27,54.81 -456.54,251.09 c -1.36,-2.37 -2.69,-4.77 -4.09,-7.12 l 487.63,-298.78",
    id: "path76",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3751.35,3894.62 24.96,24.98 -540.95,391.76 c -2.02,-2.94 -4.08,-5.85 -6.17,-8.73 l 522.16,-408.01",
    id: "path78",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2998.09,4483.12 59.67,-46.61 2.45,1.64 -62.12,44.97",
    id: "path80",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3613.66,3932.62 -24.91,56.46 -384.64,282.3 c -1.51,-1.7 -3.04,-3.37 -4.56,-5.04 l 414.11,-333.72",
    id: "path82",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2424.83,4065.01 38.92,-43.26 43.25,19.47 21.62,-21.62 43.25,25.95 17.3,58.37 -41.08,25.95 -62.91,0 -51.53,-47.23 -8.82,-17.63",
    id: "path84",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2026.96,3794.71 45.41,-43.24 361.28,331.17 51.53,47.23 156.62,143.57 c -2.13,2.43 -4.19,4.92 -6.26,7.4 l -608.58,-486.13",
    id: "path86",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2068.05,4067.17 2.16,-28.12 520.82,306.59 c -0.61,1.09 -1.17,2.22 -1.76,3.32 l -521.22,-281.79",
    id: "path88",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2258.33,4276.91 -4.33,-32.44 332.43,109.84 c -1.56,2.94 -3.1,5.89 -4.59,8.87 l -323.51,-86.27",
    id: "path90",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2156.7,4188.26 0,38.92 -114.61,6.48 67.04,-64.86 47.57,19.46",
    id: "path92",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1862.62,4023.92 -64.87,41.09 -23.79,-77.85 66.09,-90.87 3.11,-4.28 21.63,60.55 41.08,2.16 25.95,28.11 12.97,41.09 -62.71,23.8 -19.46,-23.8",
    id: "path94",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1611.79,4170.96 -6.49,-32.44 969.56,239.34 c -0.81,1.79 -1.55,3.63 -2.34,5.44 l -960.73,-212.34",
    id: "path96",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2557.96,4421.57 -1279.18,-146.82 -2.15,-28.11 1281.96,173.08 c -0.21,0.62 -0.42,1.23 -0.63,1.85",
    id: "path98",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1754.5,4395.85 0,-25.96 185.96,-17.3 -118.93,92.98 -67.03,-49.72",
    id: "path100",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2215.09,4525.59 -84.34,4.31 -10.04,-16.56 105.02,-6.93 -10.64,19.18",
    id: "path102",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2297.26,4508.29 -15.58,-5.57 16.16,-1.06 -0.58,6.63",
    id: "path104",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2236.7,4486.66 -4.65,8.39 -119.52,4.8 -25.03,-41.29 69.2,-49.74 75.68,-12.97 23.79,38.92 47.57,0 -5.08,57.6 -41.31,1.66 -20.65,-7.37",
    id: "path106",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2297.84,4501.66 -16.16,1.06 -55.95,3.69 -105.02,6.93 -513.24,33.86 25.95,-28.11 479.11,-19.24 119.52,-4.8 25.3,-1.02 41.31,-1.66 246,-9.88 1.07,2.81 -247.89,16.36",
    id: "path108",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2656.21,4478.01 -107.79,7.11 12.47,-3.28 95.32,-3.83",
    id: "path110",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2174,4627.21 -32.44,-28.11 512.48,-80.01 -480.04,108.12",
    id: "path112",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2673.51,4540.72 -350.31,185.97 8.65,-21.64 341.66,-164.33",
    id: "path114",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2714.58,4560.18 -65.74,49.53 -7.39,-0.42 73.13,-49.11",
    id: "path116",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2418.34,4759.11 131.13,-88.05 c 0.95,3.78 1.88,7.57 2.93,11.31 l -153.52,115.67 19.46,-38.93",
    id: "path118",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2572.52,4383.3 c 0.79,-1.81 1.53,-3.65 2.34,-5.44 2.23,-4.95 4.57,-9.84 6.98,-14.68 1.49,-2.98 3.03,-5.93 4.59,-8.87 0.93,-1.79 1.88,-3.58 2.84,-5.35 0.59,-1.1 1.15,-2.23 1.76,-3.32 12.89,-23.17 27.85,-44.82 44.51,-64.8 2.07,-2.48 4.13,-4.97 6.26,-7.4 70.73,-80.85 170.93,-131.32 282.07,-131.32 107.83,0 205.36,47.54 275.68,124.22 1.52,1.67 3.05,3.34 4.56,5.04 8.82,9.95 17.19,20.39 25.08,31.25 2.09,2.88 4.15,5.79 6.17,8.73 5.09,7.38 10,14.91 14.63,22.65 1.4,2.35 2.73,4.75 4.09,7.12 8.69,15.19 16.54,31 23.41,47.4 1.91,4.56 3.75,9.18 5.5,13.83 4.46,11.75 8.49,23.73 11.97,35.99 l -57.22,20.48 -12.68,21.55 -0.18,0.31 -9.6,16.32 -61.46,48.86 -0.22,0.17 -25.91,20.6 0,-83.1 -67.48,-45.39 -2.45,-1.64 -53.62,-36.07 -168.46,143.75 -119.04,-103.33 -155.75,40.98 -12.47,3.28 -2.5,0.66 -0.19,-0.48 -1.07,-2.81 -1.34,-3.51 c 3.61,-19.68 8.57,-38.83 14.64,-57.41 0.21,-0.62 0.42,-1.23 0.63,-1.85 4.12,-12.43 8.77,-24.57 13.93,-36.42",
    id: "path120",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2548.03,4665.51 54.05,-58.44 39.37,2.22 7.39,0.42 112.71,6.36 157.23,-78.63 89.85,107.82 -40.43,98.83 123.54,-13.47 17.97,74.12 75.22,-0.88 14.94,-0.18 62.58,-0.73 c -8.27,12.59 -17.53,24.61 -27.52,36.12 -2.85,3.28 -5.86,6.44 -8.84,9.63 -22.5,24.07 -48.55,45.43 -77.03,63.57 -1.92,1.23 -3.83,2.47 -5.76,3.66 -0.98,0.59 -1.91,1.23 -2.88,1.82 -24.87,15.01 -51.42,27.52 -78.88,37.36 -3.89,1.39 -7.78,2.8 -11.7,4.08 -0.78,0.25 -1.54,0.56 -2.33,0.81 -40.33,12.93 -82.31,19.94 -123.64,19.94 -175.21,0 -323.29,-125.38 -371.47,-297.57 -1.05,-3.74 -1.98,-7.53 -2.93,-11.31 -0.47,-1.86 -0.99,-3.69 -1.44,-5.55",
    id: "path122",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.113702,-23.920505)",
    id: "g3039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3484.04,1533.44 c -5.43,-18.42 -13.45,-33.15 -24.04,-44.18 -15.46,-16.15 -35.49,-26.92 -60.1,-32.29 -15.47,-3.39 -42.5,-5.95 -81.13,-7.65 l 0,-83.75 146.25,0 0,-430 124.98,0 0,622.5 -101.23,0 c 0,-5.39 -1.58,-13.6 -4.73,-24.63",
    id: "path124",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 55,500 c 0,0 443.3666,-445 445,-445 1.3076,0 445,443.69239 445,445 0,1.63343 -445,445 -445,445 C 500,945 55,500 55,500 z M 925,500 500,75 c 0,0 -425,425 -425,425 0,0 425,425 425,425 L 925,500 z",
    id: "path2820",
    style: {
      fill: "#080400"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 415.26654,
    y: 796.34534,
    id: "text2819",
    xmlSpace: "preserve",
    style: {
      fontSize: 20,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "FreeSans",
      InkscapeFontSpecification: "FreeSans Bold"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 415.26654,
    y: 796.34534,
    id: "tspan2821"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 424.46704,
    y: 773.9657,
    id: "text2853",
    xmlSpace: "preserve",
    style: {
      fontSize: 20,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "Verdana",
      InkscapeFontSpecification: "Verdana Bold"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 424.46704,
    y: 773.9657,
    id: "tspan2855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/1.5.f882a3927c15e8f1702e05b23782915f.svg";
export { ForwardRef as ReactComponent };